import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate, useParams } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import ServicePage from './pages/ServicePage';
import Contact from './pages/Contact';
import { LanguageProvider } from './context/LanguageContext';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
}

// Redirect helper for old service detail URLs
function ServiceRedirect() {
  const { id } = useParams();
  return <Navigate to={`/ydelser/${id}`} replace />;
}

export default function App() {
  return (
    <LanguageProvider>
      <Layout>
        <Routes>
          {/* Danish Routes (Primary) */}
          <Route path="/" element={<Home />} />
          <Route path="/ydelser" element={<Services />} />
          <Route path="/ydelser/:id" element={<ServicePage />} />
          <Route path="/kontakt" element={<Contact />} />

          {/* English Routes */}
          <Route path="/en" element={<Home />} />
          <Route path="/en/services" element={<Services />} />
          <Route path="/en/services/:id" element={<ServicePage />} />
          <Route path="/en/contact" element={<Contact />} />

          {/* 301 Redirects from old URLs to new URLs */}
          <Route path="/services" element={<Navigate to="/ydelser" replace />} />
          <Route path="/services/:id" element={<ServiceRedirect />} />
          
          {/* Fallback redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </LanguageProvider>
  );
}
